import { Box, Button, Modal } from '@workwhile/ui'
import { WorkerRowBreaksTable } from 'pages/Shifts/ShiftDetail/components/WorkerRow/WorkerRowBreaksTable'
import React, { useState } from 'react'

type WorkBreaksButtonProps = {
  shiftId: number
  workId: number
  timezone: string
  clockedInAt?: string | null
  clockedOutAt?: string | null
  onEditClose: () => void
}

export const WorkBreaksButton = ({
  shiftId,
  workId,
  timezone,
  clockedInAt,
  clockedOutAt,
  onEditClose,
}: WorkBreaksButtonProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Box mb={2}>
      <Button variant="secondary" size="small" onClick={() => setOpen(true)}>
        View breaks
      </Button>
      {open ? (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          title="Breaks"
          // @ts-expect-error width is not typed
          width="90vw"
          maxWidth="1400px"
        >
          <WorkerRowBreaksTable
            shiftId={shiftId}
            workId={workId}
            timezone={timezone}
            clockedInAt={clockedInAt}
            clockedOutAt={clockedOutAt}
            allowEdit
            onEditClose={onEditClose}
          />
        </Modal>
      ) : null}
    </Box>
  )
}
